import * as React from 'react';
import isEmpty from 'lodash/isEmpty';
import pick from 'lodash/pick';

import DeliverableV2 from 'modules/deliverables/components/deliverable-v2/Deliverable';

import type {
  Deliverable,
  DeliverableV2TabKey,
  SubcampaignWithInfluencerSettings
} from 'types';

type Props = {
  subcampaign: SubcampaignWithInfluencerSettings,
  deliverables: Array<Deliverable>
};

const CcmOfferDeliverables: React.FC<Props> = ({
  subcampaign,
  deliverables
}): JSX.Element | null => {
  const [isExpanded, setIsExpanded] = React.useState(true);
  const [selectedTab, setSelectedTab] = React.useState<DeliverableV2TabKey>('information');

  if (isEmpty(deliverables)) {
    return null;
  }

  return (
    <div className="ccm-offer-deliverables">
      {
        deliverables.map(deliverable => (
          <DeliverableV2
            key={deliverable.id}
            subcampaign={subcampaign}
            deliverable={deliverable}
            deliverablesWithCA2={deliverables
              .map(d => pick(d, ['id', 'name', 'deliverableType', 'tag']))
              .map(d => ({ ...d, type: d.deliverableType }))
            }
            isExpanded={isExpanded}
            selectedTab={selectedTab}
            isForBrand
            isCcm
            onTrackDeliverableUploadEvent={() => {}}
            onContentMoved={() => {}}
            onExpanded={() => setIsExpanded((prevState) => !prevState)}
            onViewChange={(updatedTab: DeliverableV2TabKey) => setSelectedTab(updatedTab)}
          />
        ))
      }
    </div>
  );
};

export default CcmOfferDeliverables;
